import {IUserRules} from '@ui-app/services/user-rules-reader.service';
import {CountryEnum} from '@shared-models/common.models';
import {FilterConfig} from '@employee-pages/badge-request-page/employee-badge-requests';
import {AbstractControl, ValidationErrors, ValidatorFn} from '@angular/forms';

export const USER_RULES: IUserRules = {
    passByCountry: {
        countries: [
            CountryEnum.USI
        ]
    }
};


export const TAKE_PHOTO_SUBMIT = {
    4: true,  // InitialBadgeRequest – FTE MissingPhoto
    5: true,
    6: true,
    8: false
};

export const LOCATION_FILTER_CONFIG: FilterConfig = {
    filterField: 'siteName',
    placeholder: 'Search',
    noDataText: 'No results found',
    minHighlightLength: 1,
    simpleView: false,
    strictFiltering: false,
    type: 'simple',
    filterLimit: 6,
};

export function dateInPastValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const value = control.value;

        if (!value) {
            return null;
        }

        const now = new Date();
        const valueDatepicker = new Date(value);
        if (!isValidDate(valueDatepicker)) {
            return {dateInPast: true};
        }
        return valueDatepicker > now ? {dateInPast: true} : null;
    };
}

export function dateInPastCheck(control: AbstractControl): boolean {
    const value = control.value;

    if (!value) {
        return false;
    }

    const now = new Date();
    const valueDatepicker = new Date(value);

    if (!isValidDate(valueDatepicker)) {
        return false;
    }
    return valueDatepicker <= now;
}


function isValidDate(d: Date): boolean {
    return d instanceof Date && !isNaN(Number(d));
}
